import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'statusTimeFormat' })
export class StatusTimeFormatPipe implements PipeTransform {

    private formatZeros(num: number): string {
        return (num < 10 ? '0' : '') + num;
    }

    public transform(seconds: number): string {

        if (seconds < 0) {
            return '';
        }

        let minutes = Math.ceil(seconds / 60);

        let years = Math.floor(minutes / 60 / 24 / 365);
        let rest = minutes - years * 30 * 24 * 365;

        let months = Math.floor(rest / 60 / 24 / 30);
        rest = rest - months * 30 * 24 * 60;

        let weeks = Math.floor(rest / 60 / 24 / 7);
        rest = rest - weeks * 7 * 24 * 60;

        let days = Math.floor((rest) / 60 / 24);
        rest = rest - days * 24 * 60;

        let hours = Math.floor((rest) / 60);
        rest = rest - hours * 60;

        let mins = Math.floor((rest) / 1);


        if (years) {
            if (months) {
                weeks = 0;
                days = 0;
                hours = 0;
                mins = 0;
            } else if (weeks) {
                days = 0;
                hours = 0;
                mins = 0;
            } else if (days) {
                hours = 0;
                mins = 0;
            } else if (hours) {
                mins = 0;
            } else if (mins) {
                mins = 0;
            }
        } else {
            if (months) {
                if (weeks) {
                    days = 0;
                    hours = 0;
                    mins = 0;
                } else if (days) {
                    hours = 0;
                    mins = 0;
                } else if (hours) {
                    mins = 0;
                } else if (mins) {
                    mins = 0;
                }
            } else {
                if (weeks) {
                    if (days) {
                        hours = 0;
                        mins = 0;
                    } else if (hours) {
                        mins = 0;
                    } else if (mins) {
                        mins = 0;
                    }
                } else {
                    if (days) {
                        if (hours) {
                            mins = 0;
                        } else if (mins) {
                            mins = 0;
                        }
                    } else {

                    }
                }
            }
        }

        let res = '';
        if (years) {
            if (res) {
                res += ' ';
            }
            res += years + ' y';
        }
        if (months) {
            if (res) {
                res += ' ';
            }
            res += months + ' m';
        }
        if (weeks) {
            if (res) {
                res += ' ';
            }
            res += weeks + ' w';
        }
        if (days) {
            if (res) {
                res += ' ';
            }
            res += days + ' d';
        }
        if (hours && !mins) {
            if (res) {
                res += ' ';
            }
            res += hours + ' h';
        } else if (!hours && mins) {
            if (res) {
                res += ' ';
            }
            res += mins + ' min';
        } else if (hours && mins) {
            if (res) {
                res += ' ';
            }
            res += hours + ':' + this.formatZeros(mins) + ' h';
        }

        if (years >= 3) {
            res = '> 3 y';
        }

        return res;
    }
}
